(function () {
  'use strict';

  // 캔버스 해상도 — 높일수록 정밀하지만 샘플링 시간 증가 (권장: 400~800)
  var CANVAS_RES    = 600;

  // 파티클 샘플 간격 — 낮을수록 파티클 수↑·밀도↑, 성능 하락 (권장: 2~5)
  var STEP          = 3;

  // 픽셀 인식 밝기 임계값 — 높일수록 더 밝은 픽셀도 파티클로 인식 (0~255, 권장: 80~150)
  var DARK_THRESH   = 120;

  // spread 시 파티클이 home에서 벗어나는 최소·최대 거리 (캔버스 px)
  // 높일수록 더 넓게 퍼짐 — MIN과 MAX의 차이가 클수록 분산 분포가 넓어짐
  var SPREAD_MIN    = 80;
  var SPREAD_MAX    = 100;

  // 마우스 원의 반경 (캔버스 px) — 클수록 더 넓은 범위의 파티클이 반응
  var REPEL_RADIUS  = 24;

  // 마우스 원 테두리 두께 (캔버스 px) — 캔버스가 CSS로 축소되므로 화면상 실제보다 얇게 보임
  var CURSOR_STROKE = 2;

  // ── 위젯 열림 (spread) ──────────────────────────────────────
  // 스프링 거리비례 계수 — 높을수록 멀리 있을 때 더 강하게 당겨짐 (권장: 0~0.005)
  var SPREAD_SPRING_K    = 0.0001;
  // 스프링 기본 인력 — 높을수록 항상 일정하게 당겨짐, 너무 높으면 spread 위치에 붙어버림 (권장: 0~0.01)
  var SPREAD_SPRING_BASE = 0.001;
  // 감쇠 — 1에 가까울수록 속도가 오래 유지되어 미끄럽게 떠다님, 낮을수록 빠르게 정지 (권장: 0.88~0.98)
  var SPREAD_DAMPING     = 0.94;
  // Perlin 노이즈 크기 — 높을수록 파티클이 불규칙하게 크게 떠다님 (권장: 0~0.5)
  var SPREAD_NOISE       = 0.10;
  // 마우스 원과의 반발력 — 낮을수록 파티클이 무겁게 조금만 밀림 (권장: 1~30)
  var SPREAD_REPEL_FORCE = 2;

  // ── 위젯 닫힘 (assemble) ────────────────────────────────────
  // 스프링 거리비례 계수 — 높을수록 home에서 멀수록 강하게 복귀 (권장: 0.003~0.01)
  var ASSEMBLE_SPRING_K    = 0.01;
  // 스프링 기본 인력 — 높을수록 빠르게 복귀, 너무 높으면 진동 발생 (권장: 0.02~0.06)
  var ASSEMBLE_SPRING_BASE = 0.02;
  // 감쇠 — 낮을수록 복귀 후 빠르게 정지하여 로고 형태가 또렷해짐 (권장: 0.78~0.88)
  var ASSEMBLE_DAMPING     = 0.8;
  // Perlin 노이즈 크기 — 낮을수록 파티클이 home 근처에 정확히 머묾 (권장: 0~0.1)
  var ASSEMBLE_NOISE       = 0.05;
  // 마우스 원과의 반발력 — 높을수록 파티클이 민감하게 튕겨나감 (권장: 10~40)
  var ASSEMBLE_REPEL_FORCE = 20;

  function init() {
    if (typeof p5 === 'undefined' || !window.suonoSymbolUrl) return;

    new p5(function (sk) {
      var particles = [];
      var symbolImg;
      var ready = false;
      var mousePos    = null;
      var mouseActive = false;
      var canvasEl    = null;

      sk.preload = function () {
        symbolImg = sk.loadImage(
          window.suonoSymbolUrl,
          function () {},
          function () { console.warn('[SUONO] Symbol image load failed'); },
          'anonymous'
        );
      };

      sk.setup = function () {
        var container = document.getElementById('footer-logo-canvas');
        if (!container) return;

        var cnv = sk.createCanvas(CANVAS_RES, CANVAS_RES);
        cnv.parent(container);
        sk.pixelDensity(Math.min(window.devicePixelRatio || 1, 2));
        sk.frameRate(60);

        canvasEl = cnv.elt;
        mousePos = sk.createVector(-9999, -9999);

        // 마우스 좌표 → 캔버스 좌표계 변환
        var btn = container.closest('.footer-widget__logo-btn') || container.parentElement;

        btn.addEventListener('mousemove', function (e) {
          if (window.innerWidth <= 1024) return;
          mouseActive = true;
          var rect = canvasEl.getBoundingClientRect();
          mousePos.x = (e.clientX - rect.left)  / rect.width  * CANVAS_RES;
          mousePos.y = (e.clientY - rect.top)    / rect.height * CANVAS_RES;
        });

        btn.addEventListener('mouseleave', function () {
          mouseActive = false;
        });

        sampleSymbol();

        window.suonoParticles = {
          spread:   function () { particles.forEach(function (p) { p.spread(); }); },
          assemble: function () { particles.forEach(function (p) { p.assemble(); }); }
        };
      };

      function sampleSymbol() {
        try {
          var g = sk.createGraphics(CANVAS_RES, CANVAS_RES);
          g.pixelDensity(1);
          g.background(255);

          var aspect = 1538.085 / 1758.42;
          var drawW  = Math.round(CANVAS_RES * aspect);
          var ox     = Math.round((CANVAS_RES - drawW) / 2);
          g.image(symbolImg, ox, 0, drawW, CANVAS_RES);
          g.loadPixels();

          if (!g.pixels || g.pixels.length === 0) throw new Error('no pixel data');

          for (var x = 0; x < CANVAS_RES; x += STEP) {
            for (var y = 0; y < CANVAS_RES; y += STEP) {
              var i = (x + y * CANVAS_RES) * 4;
              if (g.pixels[i + 3] > 100 && g.pixels[i] < DARK_THRESH) {
                particles.push(new Particle(
                  x + sk.random(-0.5, 0.5),
                  y + sk.random(-0.5, 0.5)
                ));
              }
            }
          }

          g.remove();
          ready = true;

        } catch (e) {
          console.warn('[SUONO] Pixel sampling failed, fallback active:', e);
          for (var j = 0; j < 400; j++) {
            var a = sk.random(sk.TWO_PI);
            var r = sk.random(10, 120);
            particles.push(new Particle(
              CANVAS_RES / 2 + Math.cos(a) * r,
              CANVAS_RES / 2 + Math.sin(a) * r
            ));
          }
          ready = true;
        }
      }

      sk.draw = function () {
        sk.clear();
        if (!ready) return;
        for (var i = 0; i < particles.length; i++) {
          particles[i].update();
          particles[i].render();
        }
        if (mouseActive) {
          sk.noFill();
          sk.stroke(17, 17, 17, 180);
          sk.strokeWeight(CURSOR_STROKE);
          sk.circle(mousePos.x, mousePos.y, REPEL_RADIUS * 2);
          sk.noStroke();
        }
      };

      // ── Particle ─────────────────────────────────────────────
      function Particle(hx, hy) {
        this.home = sk.createVector(hx, hy);

        var spreadDir = p5.Vector.random2D();
        spreadDir.mult(sk.random(SPREAD_MIN, SPREAD_MAX));
        this.spreadTarget = p5.Vector.add(this.home, spreadDir);

        this.pos  = this.home.copy().add(sk.createVector(sk.random(-1, 1), sk.random(-1, 1)));
        this.vel  = sk.createVector(0, 0);
        this.acc  = sk.createVector(0, 0);
        this.sz   = sk.random(2, 4);
        this.nOff = sk.random(1000);
        this.isSpread = false;
      }

      Particle.prototype.spread = function () {
        this.isSpread = true;
      };

      Particle.prototype.assemble = function () {
        this.isSpread = false;
      };

      Particle.prototype.update = function () {
        var target      = this.isSpread ? this.spreadTarget    : this.home;
        var springK     = this.isSpread ? SPREAD_SPRING_K      : ASSEMBLE_SPRING_K;
        var springB     = this.isSpread ? SPREAD_SPRING_BASE   : ASSEMBLE_SPRING_BASE;
        var damping     = this.isSpread ? SPREAD_DAMPING       : ASSEMBLE_DAMPING;
        var noiseAmp    = this.isSpread ? SPREAD_NOISE         : ASSEMBLE_NOISE;
        var repelForce  = this.isSpread ? SPREAD_REPEL_FORCE   : ASSEMBLE_REPEL_FORCE;

        var toTarget = p5.Vector.sub(target, this.pos);
        var d = toTarget.mag();

        toTarget.mult(d * springK + springB);
        this.acc = toTarget;

        var t = sk.frameCount * 0.007;
        var angle = sk.noise(
          this.pos.x * 0.004,
          this.pos.y * 0.004,
          t + this.nOff
        ) * sk.TWO_PI * 2;
        this.acc.add(p5.Vector.fromAngle(angle).mult(noiseAmp));

        // 마우스 반발력
        if (mouseActive) {
          var toMouse = p5.Vector.sub(mousePos, this.pos);
          var dMouse  = toMouse.mag();
          if (dMouse < REPEL_RADIUS && dMouse > 0.1) {
            var strength = (1 - dMouse / REPEL_RADIUS) * repelForce;
            this.acc.add(toMouse.normalize().mult(-strength));
          }
        }

        this.vel.add(this.acc).mult(damping);
        this.pos.add(this.vel);
      };

      Particle.prototype.render = function () {
        sk.noStroke();
        var d = p5.Vector.dist(this.pos, this.home);
        var alpha;
        if (this.isSpread) {
          alpha = sk.map(d, 0, SPREAD_MAX, 200, 80);
        } else {
          alpha = sk.map(d, 0, 20, 220, 100);
        }
        sk.fill(17, 17, 17, alpha);
        sk.circle(this.pos.x, this.pos.y, this.sz);
      };

    }); // end new p5()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
